import { Injectable, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { AuthActions } from '../state/auth/auth.actions';
import { TokenStorageService } from './token-storage.service';

/**
 * localStorage writes from another tab arrive as `storage` events.
 * Logout there clears both tokens; a refresh there updates the access token.
 */
@Injectable({ providedIn: 'root' })
export class AuthStorageSync {
  private readonly store = inject(Store);
  private readonly tokens = inject(TokenStorageService);
  private listening = false;

  start(): void {
    if (this.listening || typeof window === 'undefined') {
      return;
    }
    window.addEventListener('storage', this.onStorage);
    this.listening = true;
  }

  stop(): void {
    if (!this.listening || typeof window === 'undefined') {
      return;
    }
    window.removeEventListener('storage', this.onStorage);
    this.listening = false;
  }

  private readonly onStorage = (event: StorageEvent): void => {
    if (!this.tokens.isTokenKey(event.key)) {
      return;
    }
    if (!this.tokens.hasSession()) {
      this.store.dispatch(AuthActions.sessionCleared({}));
      return;
    }
    if (event.key === TokenStorageService.accessKey && event.newValue) {
      this.store.dispatch(
        AuthActions.refreshSucceeded({ token: { accessToken: event.newValue } }),
      );
    }
  };
}
